export const useAppScrollLock = createGlobalState(() => {
  if (import.meta.env.SSR) {
    const isLocked = ref(false);
    return { isLocked };
  }

  const isLocked = useScrollLock(document.documentElement);
  return { isLocked };
});
